import { Deserializable } from "../../common/deserializable";
import { CompagnieMaritime } from "./compagnieMaritime";

export class OffreCommerciale implements Deserializable {
  id: number;
  typeTransport: string;
  frequence: string;
  familleTouchee: string;
  directTransbo: string;
  empreinteCarbone: number;
  portDestinationProvenance: string;
  service: string;
  alliances: string;
  tti: string;
  uniteTti: string;
  tte: string;
  uniteTte: string;
  manuntentionairePrincip: string;
  manuntentionaireSecond: string;
  ipPrincipale: string;
  ipSecondaire: string;
  etaNextEscale: Date;
  compagnieMaritime: CompagnieMaritime;

  constructor(
    id,
    typeTransport,
    frequence,
    familleTouchee,
    directTransbo,
    empreinteCarbone,
    portDestinationProvenance,
    service,
    alliances,
    tti,
    tte,
    manuntentionairePrincip,
    manuntentionaireSecond,
    ipPrincipale,
    ipSecondaire,
    etaNextEscale,
    compagnieMaritime
  ) {}

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/offrecommerciale/model/offreCommerciale.ts